module.exports = __webpack_public_path__ + "static/media/IOD_Seal_Transparent_140px.63cded67.png";